import about1 from "../../assets/images/all-img/about2/01.png";
import about2 from "../../assets/images/all-img/about2/02.png";
import about3 from "../../assets/images/all-img/about2/03.png";
import about4 from "../../assets/images/all-img/about2/04.png";
import about5 from "../../assets/images/all-img/about2/05.png";
import about6 from "../../assets/images/all-img/about2/06.png";
import about7 from "../../assets/images/all-img/about2/07.png";
import about8 from "../../assets/images/all-img/about2/08.png";
import about9 from "../../assets/images/all-img/about2/09.png";
import breadBG from "../../assets/images/all-img/about2/bread-bg.png";

export default function AboutHeroSection() {
	return (
		<div
			className="fugu--about-hero-section dark-version"
			style={{ backgroundImage: `url(${breadBG})` }}
		>
			<div className="container">
				<div className="fugu--breadcrumb-thumb-top">
					<div className="fugu--breadcrumb-thumb thumb1">
						<img src={about6} alt="" />
					</div>
					<div className="fugu--breadcrumb-thumb thumb2">
						<img src={about7} alt="" />
					</div>
					<div className="fugu--breadcrumb-thumb thumb3">
						<img src={about8} alt="" />
					</div>
					<div className="fugu--breadcrumb-thumb thumb4">
						<img src={about9} alt="" />
					</div>
				</div>
				<div className="fugu--breadcrumb-thumb-bottom">
					<div className="fugu--breadcrumb-thumb thumb2">
						<img src={about1} alt="" />
					</div>
					<div className="fugu--breadcrumb-thumb thumb3">
						<img src={about2} alt="" />
					</div>
					<div className="fugu--breadcrumb-thumb thumb4">
						<img src={about3} alt="" />
					</div>
					<div className="fugu--breadcrumb-thumb thumb2">
						<img src={about4} alt="" />
					</div>
					<div className="fugu--breadcrumb-thumb thumb3">
						<img src={about5} alt="" />
					</div>
				</div>
			</div>
		</div>
	);
}
